import React, { useRef,useState,useEffect } from "react";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "./componentToPrint";

export default function PrintComponent({ setting, requestModels, bus }) {

    let componentRef = useRef(null);

    return (
        <>
            <div>
                {/* button to trigger printing of target component */}
                <ReactToPrint
                    trigger={() => <button className="brn btn-sm btn-primary">
                        <i className="bi bi-printer"></i>
                    </button>}
                    content={() => componentRef}
                />

                {/* component to be printed */}
                <div style={{ display: "none" }}>
                    <ComponentToPrint bus={bus} param={setting} maintenances={requestModels} ref={(el) => (componentRef = el)} />
                </div>
            </div>

        </>
    );
}